namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoHd9Service {
        export const baseUrl = 'AdvPromo/PsAdvPromoHd9';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoHd9Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoHd9Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoHd9Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoHd9Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoHd9/Create",
            Update = "AdvPromo/PsAdvPromoHd9/Update",
            Delete = "AdvPromo/PsAdvPromoHd9/Delete",
            Retrieve = "AdvPromo/PsAdvPromoHd9/Retrieve",
            List = "AdvPromo/PsAdvPromoHd9/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoHd9Service)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
